import { render, staticRenderFns } from "./IntegrationInfo.vue?vue&type=template&id=5a70625e&scoped=true"
import script from "./IntegrationInfo.vue?vue&type=script&lang=ts"
export * from "./IntegrationInfo.vue?vue&type=script&lang=ts"
import style0 from "./IntegrationInfo.vue?vue&type=style&index=0&id=5a70625e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70625e",
  null
  
)

export default component.exports